import home from '@/pages/Home/model'
import recommend from '@/pages/Recommend/model'

export default {
  home,
  recommend,
}